

































import { Component, Prop, Vue } from 'vue-property-decorator';
import RadioButton from '@/modules/business-plan/common/utils/radio-button.component.vue';
import InputComponent from '@/modules/business-plan/common/utils/input.component.vue';
import {
  IEconomicGroupGoalsDetails,
  Family,
  inputManualColumnGoalSetting,
  radioColumnGoalSetting,
  GoalsInsertViewModel,
  inputTotalManualColumnGoalSetting
} from '@/modules/business-plan/modules/approval/pages/volvo-goal-settings/types';
import { labelSalesType } from '@/modules/business-plan/modules/models/constants/salesTypes';
import { goalTypeEnum } from '@/modules/business-plan/modules/models/enums/goalTypeEnum';
import _ from 'lodash';

@Component({
  name: 'ValueEditionGoalSettingComponent',
  components: { InputComponent, RadioButton }
})
export default class ValueEditionGoalSettingComponent extends Vue {
  public val: number;
  public openJustification: boolean = false;
  public valid: boolean = true;
  public showSaveButton: boolean = false;
  public currentValue: number;

  @Prop({ required: true })
  public column: radioColumnGoalSetting | inputTotalManualColumnGoalSetting;

  @Prop({ required: true })
  public family: Family;

  @Prop({ required: true })
  public goal: IEconomicGroupGoalsDetails;

  @Prop({ required: true })
  public goals: IEconomicGroupGoalsDetails[];

  @Prop({ required: true })
  public needArbitratedGoalJustification: boolean;

  private originalGoal = { ...this.goal };

  public created() {
    this.updateInternalValue();
    this.goal.showSaveButton = false;
    this.goal.inputValue = this.goal.inputValue > 0 ? this.goal.inputValue : 0;
    this.$set(this.goal, 'styleInput', '');
  }

  public showButton() {
    if (this.needArbitratedGoalJustification) {
      if (!this.goal.isRadioSelected)
        this.currentValue = this.val;
      else {
        this.currentValue = 0;
        this.goal.isRadioSelected = false;
      }

      this.goal.showSaveButton = true;
      this.$set(this.goal, 'styleInput', 'ui action input');
    }
  }

  public verifyCurrentValue() {
    if (this.val == this.currentValue) {
      this.hideSaveButton();
    }
  }

  public hideSaveButton() {
    this.goal.showSaveButton = false;
    this.$set(this.goal, 'styleInput', '');
  }

  public updateInternalValue() {
    const { goalValueTotal } = this.goal;

    this.val = goalValueTotal;
  }

  public updateExternalValue() {
    const { val } = this;

    this.goal.goalTypeSelected = this.column.type;
    this.goal.goalValueTotal = val;
    this.goal.inputValue = val;

    if ((this.column as inputTotalManualColumnGoalSetting).calculateProportional) {
      (this.column as inputTotalManualColumnGoalSetting).calculateProportional(val, this.goals);
    }
  }

  public get typeManual(): boolean {
    return this.goal.goalTypeSelected === goalTypeEnum.Manual;
  }

  public updateRadioValue() {
    this.goals.forEach((goal) => {
      goal.goalValue = goal.businessPlan;
    });

    this.val = this.column.getterValue(this.goal) as number;
    this.goal.justification = '';

    this.hideSaveButton();
    this.updateExternalValue();

    this.goal.isRadioSelected = true;
    this.goal.inputValue = 0;
    this.goal.goalValueTotal = this.goals.sumBy(x => x.businessPlan);
    this.goals.forEach((goal) => {
      goal.goalValueTotal = this.goal.goalValueTotal;
    });

    this.goal.goalTypeSelected = goalTypeEnum.BusinessPlan;
  }

  public toggleJustification() {
    this.$emit('toggleJustification');
  }

  public handleInputKeyUp(value) {
    this.goal.goalTypeSelected = goalTypeEnum.Manual;
    this.val = Number(value);

    this.updateExternalValue();
  }

  public updateValid(): void {
    const { val,  } = this;

    if (!this.isValidNumber(val)) {
      this.resetGoal();
      return;
    }

    this.updateExternalValue();
    this.hideSaveButton();

    this.goal.inputValue = parseInt(val.toString());
  }

  public get hiddenCell(): string {
    const { column } = this;
    const col = column as radioColumnGoalSetting;
    return col.isRadio ? '' : 'hidden';
  }

  public get isRadioMarked(): boolean {
    const { goal, family, column } = this;
    const col = column as radioColumnGoalSetting;

    const result = goal.goalTypeSelected === col.type;

    if (result && goal.goalValue !== col.getterValue(goal)) {
      console.log(`The goal of ${labelSalesType(goal.idSaleType)} for ${family.name} product was changed from
          ${goal.goalValue} to ${col.getterValue(goal)}. If you save, this will be updated`);
    }

    return result;
  }

  public set valueInput(val: number | undefined) {
    if (!!val) val = parseInt(val.toString().replace('-', ''));

    const newVal = parseInt((val || '').toString(), 10);

    if (!this.isValidNumber(newVal)) {
      this.resetGoal();
      return;
    }

    this.val = newVal;
    if (!this.valid) {
      return;
    }
  }

  public get valueInput(): number | undefined {
    const { column, goal } = this;
    const col = column as inputManualColumnGoalSetting;

    if (goal.goalTypeSelected !== col.type)
      return;

    this.goal.inputValue = this.val;
    return this.val;
  }

  private isValidNumber(value): boolean {
    return !isNaN(value) && Number.isInteger(value) && value >= 0;
  }

  private resetGoal() {
    this.goal.goalTypeSelected = this.originalGoal.goalTypeSelected;
    this.goal.goalValue = this.originalGoal.goalValue;
    this.goal.justification = this.originalGoal.justification;
    this.valid = true;

    if (this.originalGoal.goalTypeSelected === goalTypeEnum.Manual) {
      this.val = this.originalGoal.goalValue;
      this.valueInput = this.originalGoal.goalValue;
    }
  }

  private cancelModalConfirmation() {
    this.valueInput = undefined;
    this.val = 0;

    this.goal.goalTypeSelected = goalTypeEnum.BusinessPlan;
    this.goal.goalValue = this.goal.businessPlan;
    this.valid = true;
    this.goal.justification = '';
    this.openJustification = !this.openJustification;
  }

  private ConfirmModal() {
    if (!this.goal.justification) return;

    this.openJustification = !this.openJustification;
    this.valid = true;
  }
}
